/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { MODAL_BODY, SESSION_STORAGE_KEYS } from "../../constants/constant";
import {
  addChatData,
  setPaticipantId,
} from "../../redux/slices/ChatSlice/chatSlice";
import { addUserDetails } from "../../redux/slices/FormSlice/formSlice";
import { getSessionStorage, setSessionStorage } from "../../util/UtilMethods";
import ChatForm from "../chatForm/ChatForm";
import CustomerSurvey from "../customerSurvey/CustomerSurvey";
import LiveChat from "../liveChat/LiveChat";
import ThankYouView from "../thankYou/ThankYouView";

const ChatModalBody = () => {
  const modalIndex = Number(
    getSessionStorage(SESSION_STORAGE_KEYS.MODAL_BODY_INDEX)
  );

  const [modalBody, setModalBody] = useState(
    modalIndex === 0 || modalIndex === undefined ? MODAL_BODY.FORM : modalIndex
  );
  const { userData } = useSelector((state) => state.form);
  const { receiveMessageList } = useSelector((state) => state.chat);
  const dispatch = useDispatch();

  useEffect(() => {
    const userDetails = getSessionStorage(SESSION_STORAGE_KEYS.USER_DETAILS);
    const chatList = getSessionStorage(SESSION_STORAGE_KEYS.CHAT_LIST);
    const paticipantId = getSessionStorage(SESSION_STORAGE_KEYS.PARTICIPANT_ID);

    if (userDetails && userDetails !== undefined) {
      dispatch(addUserDetails(JSON.parse(userDetails)));
    }
    if (chatList && chatList !== undefined) {
      dispatch(addChatData(JSON.parse(chatList)));
    }
    if (paticipantId && paticipantId !== undefined) {
      dispatch(setPaticipantId(paticipantId));
    }
  }, []);

  //useEffect to change modal body when user form is submiteed
  useEffect(() => {
    if (Object.keys(userData).length > 0 && receiveMessageList.length <= 0) {
      setModalBody(MODAL_BODY.LIVE_CHAT);
    }
  }, [userData]);

  useEffect(() => {
    setSessionStorage(SESSION_STORAGE_KEYS.MODAL_BODY_INDEX, modalBody);
  }, [modalBody]);

  //render the modal body
  switch (modalBody) {
    case MODAL_BODY.FORM:
      return <ChatForm setModalBody={setModalBody} />;
    case MODAL_BODY.LIVE_CHAT:
      return <LiveChat setModalBody={setModalBody} />;
    case MODAL_BODY.THANK_YOU:
      return <ThankYouView setModalBody={setModalBody} />;
    case MODAL_BODY.FEEDBACK:
      return <CustomerSurvey setModalBody={setModalBody} />;
    default:
      return <></>;
  }
};

export default ChatModalBody;
